export const VU36_DATE_IS_SET_COLOR = '#ccffcc';
